//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ParticipantsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetParticipantsParticipantsQueryParameters = {
  studyId?: number | null;
  search?: string | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

export type CreateParticipantParticipantsMutationParameters = {
  attachments?: Types.FileParameter[] | null | undefined ; 
  requestDto?: Types.CreateParticipantsRequestDto | undefined ; 
};

export type UpdateParticipantParticipantsMutationParameters = {
  attachments?: Types.FileParameter[] | null | undefined ; 
  requestDto?: Types.UpdateParticipantRequestDto | undefined ; 
};

    
export function getParticipantsUrl(studyId?: number | undefined, search?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/Participants?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "StudyId=" + encodeURIComponent("" + studyId) + "&";
if (search !== undefined && search !== null)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getParticipantsDefaultOptions: UseQueryOptions<Types.PagedResultOfParticipantDto, unknown, Types.PagedResultOfParticipantDto> = {
  queryFn: __getParticipants,
};
export function getGetParticipantsDefaultOptions(): UseQueryOptions<Types.PagedResultOfParticipantDto, unknown, Types.PagedResultOfParticipantDto> {
  return getParticipantsDefaultOptions;
};
export function setGetParticipantsDefaultOptions(options: UseQueryOptions<Types.PagedResultOfParticipantDto, unknown, Types.PagedResultOfParticipantDto>) {
  getParticipantsDefaultOptions = options;
}

export function getParticipantsQueryKey(dto: GetParticipantsParticipantsQueryParameters): QueryKey;
export function getParticipantsQueryKey(studyId?: number | undefined, search?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getParticipantsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, search, offset, limit, sortBy, sortOrder,  } = params[0] as GetParticipantsParticipantsQueryParameters;

    return trimArrayEnd([
        'ParticipantsClient',
        'getParticipants',
        studyId as any,
        search as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'ParticipantsClient',
        'getParticipants',
        ...params
      ]);
  }
}
function __getParticipants(context: QueryFunctionContext) {
  return Client.getParticipants(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortOrder | undefined    );
}

export function useGetParticipantsQuery<TSelectData = Types.PagedResultOfParticipantDto, TError = unknown>(dto: GetParticipantsParticipantsQueryParameters, options?: UseQueryOptions<Types.PagedResultOfParticipantDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param studyId (optional) 
 * @param search (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetParticipantsQuery<TSelectData = Types.PagedResultOfParticipantDto, TError = unknown>(studyId?: number | undefined, search?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.PagedResultOfParticipantDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetParticipantsQuery<TSelectData = Types.PagedResultOfParticipantDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfParticipantDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let search: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, search, offset, limit, sortBy, sortOrder,  } = params[0] as GetParticipantsParticipantsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, search, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfParticipantDto, TError, TSelectData>({
    queryFn: __getParticipants,
    queryKey: getParticipantsQueryKey(studyId, search, offset, limit, sortBy, sortOrder),
    ...getParticipantsDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfParticipantDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * @param studyId (optional) 
 * @param search (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetParticipantsData(queryClient: QueryClient, updater: (data: Types.PagedResultOfParticipantDto | undefined) => Types.PagedResultOfParticipantDto, studyId?: number | undefined, search?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getParticipantsQueryKey(studyId, search, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * @param studyId (optional) 
 * @param search (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetParticipantsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfParticipantDto | undefined) => Types.PagedResultOfParticipantDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createParticipantUrl(): string {
  let url_ = getBaseUrl() + "/api/Participants";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createParticipantMutationKey(): MutationKey {
  return trimArrayEnd([
      'ParticipantsClient',
      'createParticipant',
    ]);
}

export function useCreateParticipantMutation<TContext>(options?: Omit<UseMutationOptions<Types.ParticipantDto, unknown, CreateParticipantParticipantsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ParticipantDto, unknown, CreateParticipantParticipantsMutationParameters, TContext> {
  const key = createParticipantMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((createParticipantParticipantsMutationParameters: CreateParticipantParticipantsMutationParameters) => Client.createParticipant(createParticipantParticipantsMutationParameters.attachments, createParticipantParticipantsMutationParameters.requestDto), {...options, mutationKey: key});
}
  
    
export function updateParticipantUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/Participants/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateParticipantMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'ParticipantsClient',
      'updateParticipant',
      id as any,
    ]);
}

export function useUpdateParticipantMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.ParticipantDto, unknown, UpdateParticipantParticipantsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ParticipantDto, unknown, UpdateParticipantParticipantsMutationParameters, TContext> {
  const key = updateParticipantMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((updateParticipantParticipantsMutationParameters: UpdateParticipantParticipantsMutationParameters) => Client.updateParticipant(id, updateParticipantParticipantsMutationParameters.attachments, updateParticipantParticipantsMutationParameters.requestDto), {...options, mutationKey: key});
}
  
    
export function deleteParticipantUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/Participants/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteParticipantMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'ParticipantsClient',
      'deleteParticipant',
      id as any,
    ]);
}

export function useDeleteParticipantMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteParticipantMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.deleteParticipant(id), {...options, mutationKey: key});
}